export default {
  el: {
    colorpicker: {
      confirm: 'ठीक है',
      clear: 'साफ़ करें'
    },
    datepicker: {
      now: 'अभी',
      today: 'आज',
      cancel: 'रद्द करें',
      clear: 'साफ़ करें',
      confirm: 'ठीक है',
      selectDate: 'दिनांक चुनें',
      selectTime: 'समय चुनें',
      startDate: 'आरंभ तिथि',
      startTime: 'आरंभ समय',
      endDate: 'अंतिम तिथि',
      endTime: 'अंतिम समय',
      prevYear: 'पिछला वर्ष',
      nextYear: 'अगला वर्ष',
      prevMonth: 'पिछला महीना',
      nextMonth: 'अगला महीना',
      year: '',
      month1: 'जनवरी',
      month2: 'फ़रवरी',
      month3: 'मार्च',
      month4: 'अप्रैल',
      month5: 'मई',
      month6: 'जून',
      month7: 'जुलाई',
      month8: 'अगस्त',
      month9: 'सितंबर',
      month10: 'अक्टूबर',
      month11: 'नवंबर',
      month12: 'दिसंबर',
      week: 'सप्ताह',
      weeks: {
        sun: 'रवि',
        mon: 'सोम',
        tue: 'मंगल',
        wed: 'बुध',
        thu: 'गुरु',
        fri: 'शुक्र',
        sat: 'शनि'
      },
      months: {
        jan: 'जन',
        feb: 'फ़र',
        mar: 'मार्च',
        apr: 'अप्रै',
        may: 'मई',
        jun: 'जून',
        jul: 'जुल',
        aug: 'अगस्त',
        sep: 'सितं',
        oct: 'अक्टू',
        nov: 'नवं',
        dec: 'दिसं'
      }
    },
    select: {
      loading: 'लोड हो रहा है',
      noMatch: 'कोई मिलान वाला डेटा नहीं',
      noData: 'कोई डेटा नहीं',
      placeholder: 'चुनें'
    },
    cascader: {
      noMatch: 'कोई मिलान वाला डेटा नहीं',
      loading: 'लोड हो रहा है',
      placeholder: 'चुनें',
      noData: 'कोई डेटा नहीं'
    },
    pagination: {
      goto: 'जाओ',
      pagesize: '/पृष्ठ',
      total: 'कुल {total}',
      pageClassifier: ''
    },
    messagebox: {
      title: 'संदेश',
      confirm: 'ठीक है',
      cancel: 'रद्द करें',
      error: 'अमान्य इनपुट'
    },
    upload: {
      deleteTip: 'हटाने के लिए डिलीट दबाएं',
      delete: 'हटाएं',
      preview: 'पूर्वावलोकन',
      continue: 'जारी रखें'
    },
    table: {
      emptyText: 'कोई डेटा नहीं',
      confirmFilter: 'पुष्टि करें',
      resetFilter: 'रीसेट करें',
      clearFilter: 'सभी',
      sumText: 'योग'
    },
    tree: {
      emptyText: 'कोई डेटा नहीं'
    },
    transfer: {
      noMatch: 'कोई मिलान वाला डेटा नहीं',
      noData: 'कोई डेटा नहीं',
      titles: ['सूची 1', 'सूची 2'],
      filterPlaceholder: 'कीवर्ड दर्ज करें',
      noCheckedFormat: '{total} आइटम',
      hasCheckedFormat: '{checked}/{total} आइटम चयनित'
    },
    image: {
      error: 'विफल'
    },
    pageHeader: {
      title: 'वापस'
    },
    popconfirm: {
      confirmButtonText: 'हाँ',
      cancelButtonText: 'नहीं'
    },
    empty: {
      description: 'कोई डेटा नहीं'
    }
  }
};